export default {
    OPEN_REPORT(state, payload) {
        state.payload = payload
    },
    CLOSE_REPORT(state) {
        state.payload = null
    }
}
